// 路由示例
import type { RouteRecordRaw } from "vue-router";
import { RouterName } from "@/enums/RouterEnum";
import { t } from "@/plugins/i18n";

const webRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "layout",
    component: () => import("@/layout/index.vue"),
    children: [
      {
        path: "/",
        name: RouterName.RECOMMEND,
        component: () => import("@/views/recommend/index.vue"),
        meta: {
          title: "推荐",
        },
      },
      {
        path: "/index",
        redirect: "/",
      },

      {
        path: "/payment/:id",
        name: RouterName.PAYMENT,
        component: () => import("@/views/dataDetail/PaymentPage.vue"),
        meta: {
          title: "发布数据",
        },
      },
      {
        path: "/paymentResult/:id",
        name: RouterName.PAYMENTRESULT,
        component: () => import("@/views/dataDetail/PaymentResult.vue"),
        meta: {
          title: "发布数据",
        },
      },
      {
        path: "/download",
        name: RouterName.DOWNLOAD,
        component: () => import("@/views/downloadClient/index.vue"),
        meta: {
          title: "发布数据",
        },
      },
      {
        path: "/orders",
        name: RouterName.ORDER_LIST,
        component: () => import("@/views/dataMarket/index.vue"),
        meta: {
          title: "我的订单",
        },
      },
      {
        path: "/userCenter",
        name: RouterName.USER_CENTER,
        component: () => import("@/views/userCenter/index.vue"),
        meta: {
          title: "个人中心",
        },
        children: [
          {
            path: "userInfo",
            name: "userInfo",
            component: () => import("@/views/userCenter/userInfo/index.vue"),
            meta: {
              title: "个人信息",
            },
          },
          {
            path: "dataSeller",
            name: "dataSeller",
            meta: {
              title: "数据卖家",
            },
            children: [
              {
                path: "review",
                name: "review",
                component: () => import("@/views/userCenter/review/index.vue"),
                meta: {
                  title: "我的审核",
                },
              },
              {
                path: "myWallet",
                name: "myWallet",
                component: () =>
                  import("@/views/userCenter/myWallet/index.vue"),
                meta: {
                  title: "我的钱包",
                },
                children: [
                  {
                    path: "openPersonalAccount",
                    name: "openPersonalAccount",
                    component: () =>
                      import(
                        "@/views/userCenter/openPersonalAccount/index.vue"
                      ),
                    meta: {
                      title: "开通个人账户",
                    },
                  },
                ],
              },
              {
                path: "myTrade",
                name: RouterName.MY_TRADE,
                component: () => import("@/views/userCenter/myTrade/index.vue"),
                meta: {
                  title: "销售订单",
                },
              },
              {
                path: "myData",
                name: RouterName.MY_DATA,
                component: () => import("@/views/myData/index.vue"),
                meta: {
                  title: t("routes.myData"),
                },
                children: [
                  {
                    path: "myDataDetail/:id",
                    name: RouterName.EDIT_DATA_DETAIL,
                    component: () => import("@/views/myData/EditData.vue"),
                    meta: {
                      title: "修改信息",
                    },
                  },
                  {
                    path: "myAPIDataDetail/:id",
                    name: RouterName.EDIT_API_DATA_DETAIL,
                    component: () => import("@/views/myData/EditAPIData.vue"),
                    meta: {
                      title: "修改信息",
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "buyer",
            name: "buyer",
            meta: {
              title: t("sys.menu.buyer"),
            },
            children: [
              {
                path: "myOrder",
                name: RouterName.MY_ORDER,
                component: () => import("@/views/myOrder/index.vue"),
                meta: {
                  title: t("routes.myOrder"),
                },
                children: [
                  {
                    path: "myOrderDetail/:id",
                    name: RouterName.ORDER_DETAIL,
                    component: () => import("@/views/myOrder/Details.vue"),
                    meta: {
                      title: "订单详情",
                    },
                  },
                  {
                    path: "myApiOrderDetail/:id",
                    name: RouterName.API_ORDER_DETAIL,
                    component: () => import("@/views/myOrder/ApiDetails.vue"),
                    meta: {
                      title: "订单详情",
                    },
                  },
                ],
              },
              {
                path: "myApi",
                name: RouterName.MY_API,
                component: () => import("@/views/myApi/index.vue"),
                meta: {
                  title: t("routes.myApi"),
                },
                children: [
                  {
                    path: "guidanceDetail/:id",
                    name: RouterName.GUIDANCE_DETAIL,
                    component: () => import("@/views/myApi/GuidanceDetail.vue"),
                    meta: {
                      title: "使用指南",
                    },
                  },
                ],
              },
              {
                path: "myReport",
                name: RouterName.MY_REPORT,
                component: () => import("@/views/myReport/index.vue"),
                meta: {
                  title: t("routes.myReport"),
                },
              },
            ],
          },
          {
            path: "myMessage",
            name: "myMessage",
            component: () => import("@/views/userCenter/myMessage/index.vue"),
            meta: {
              title: "我的消息",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/home",
    redirect: "/",
  },
  {
    path: "/dataMarket",
    name: RouterName.DATA_MARKET,
    component: () => import("@/views/dataMarket/index.vue"),
    meta: {
      title: "数据集市",
    },
  },
  {
    path: "/prevalidate",
    name: RouterName.PREVALIDATE,
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/recommendList",
    redirect: "/",
  },
  {
    path: "/trend",
    name: RouterName.TREND,
    component: () => import("@/views/recommend/index.vue"),
    meta: {
      title: "趋势",
    },
  },
  {
    path: "/publish-data",
    name: RouterName.PUBLISH_DATA_WEB,
    component: () => import("@/views/downloadClient/PublishData.vue"),
    meta: {
      title: "发布数据",
    },
  },
  {
    path: "/community/:path(.+)*",
    name: RouterName.RESPONSIVE,
    component: () => import("@/views/responsive/index.vue"),
    meta: {
      title: "有求必应",
    },
  },
  {
    path: "/story/:id?",
    name: RouterName.STORY,
    component: () => import("@/views/story/index.vue"),
    meta: {
      title: "活动详情",
    },
  },
  {
    path: "/story/",
    redirect: "/story",
  },
  {
    path: "/guidance/:id",
    name: RouterName.USER_GUIDANCE,
    component: () => import("@/views/myApi/Guidance.vue"),
    meta: {
      title: "使用指南",
    },
  },
  {
    path: "/callback",
    name: RouterName.CALLBACK,
    component: () => import("@/views/login/callback.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/cliCallback",
    name: RouterName.CLICALLBACK,
    component: () => import("@/views/login/cliCallback.vue"),
    meta: {
      title: "登录",
      hideFloatingService: true,
    },
  },
  {
    path: "/clientCallback",
    name: RouterName.CLIENT_CALLBACK,
    component: () => import("@/views/login/clientCallback.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/dataDetail/:id",
    name: RouterName.DATA_DETAIL,
    component: () => import("@/views/dataDetail/index.vue"),
    meta: {
      title: "数据详情",
    },
  },
  {
    path: "/dataAPIDetail/:id",
    name: RouterName.API_DATA_DETAIL,
    component: () => import("@/views/apiDataDetail/index.vue"),
    meta: {
      title: "数据详情",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: RouterName.NOT_FOUND,
    component: () => import("@/views/error/404.vue"),
    meta: {
      title: "404 Not Found",
    },
  },
];

export default webRoutes;
